// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Select-norm — first-run setup (INCYIA) */

.sn-page {
  max-width: 1200px;
  margin: 0 auto;
  padding: 12px 20px 56px;
  min-height: calc(100vh - 72px);
  box-sizing: border-box;
  font-family: Lato, sans-serif;
  color: #0b1e2d;
  background: #fff;
}

.sn-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 20px;
  flex-wrap: wrap;
  margin-bottom: 22px;
}

.sn-eyebrow {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin: 0 0 10px;
  padding: 5px 11px 5px 5px;
  border-radius: 999px;
  background: #e2f7f2;
  border: 1px solid #c8ebe4;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #076b5c;
}

.sn-eyebrow-dot {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  display: grid;
  place-items: center;
  background: #0d9b87;
  color: #fff;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0;
}

.sn-title {
  margin: 0;
  font-size: 30px;
  font-weight: 800;
  letter-spacing: -0.03em;
  line-height: 1.12;
  background: linear-gradient(115deg, #00146d 0%, #00146d 45%, #0d9b87 100%);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  max-width: 18ch;
}

.sn-title-bar {
  width: 44px;
  height: 4px;
  border-radius: 99px;
  margin-top: 12px;
  background: linear-gradient(90deg, #0d9b87, #4fe0c2);
}

.sn-sub {
  margin: 12px 0 0;
  font-size: 16px;
  font-weight: 600;
  color: #5b6b87;
  line-height: 1.55;
  max-width: 48ch;
}

.sn-head-aside {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 12px;
  flex-shrink: 0;
}

.sn-progress {
  display: flex;
  align-items: center;
  gap: 8px;
}

.sn-progress-seg {
  width: 36px;
  height: 6px;
  border-radius: 99px;
  background: #dee4f0;
  transition: background 0.2s;
}

.sn-progress-seg.is-on {
  background: #0d9b87;
}

.sn-progress-label {
  font-size: 13px;
  font-weight: 700;
  color: #8b99b4;
  margin-left: 2px;
}

.sn-save {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 46px;
  padding: 0 22px;
  border: none;
  border-radius: 10px;
  background: #00146d;
  color: #fff;
  font-family: Lato, sans-serif;
  font-size: 14.5px;
  font-weight: 700;
  cursor: pointer;
  width: auto !important;
  box-shadow: 0 1px 2px rgba(0, 20, 109, 0.35);
  transition: background 0.14s, opacity 0.14s;
}

.sn-save:hover:not(:disabled) {
  background: #1b2f8f;
}

.sn-save:disabled {
  opacity: 0.45;
  cursor: not-allowed;
  box-shadow: none;
}

.sn-layout {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  align-items: start;
}

.sn-col {
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-width: 0;
}

.sn-card {
  background: #fff;
  border: 1px solid #dee4f0;
  border-radius: 16px;
  box-shadow: 0 12px 36px -28px rgba(0, 20, 109, 0.35);
  overflow: hidden;
}

.sn-card-head {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 18px 20px 14px;
  border-bottom: 1px solid #eaeff7;
  background: #fff;
}

.sn-card-n {
  width: 28px;
  height: 28px;
  border-radius: 8px;
  display: grid;
  place-items: center;
  font-size: 12.5px;
  font-weight: 800;
  background: #eaeff7;
  color: #5b6b87;
  flex-shrink: 0;
}

.sn-card-n.is-done {
  background: #0d9b87;
  color: #fff;
}

.sn-card-copy h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 800;
  color: #0b1e2d;
  letter-spacing: -0.01em;
}

.sn-card-copy p {
  margin: 3px 0 0;
  font-size: 14.5px;
  font-weight: 600;
  color: #8b99b4;
  line-height: 1.4;
}

.sn-card-body {
  padding: 16px 20px 20px;
}

/* Equal norm tiles — override global button { width: fit-content } */
.sn-norm-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(165px, 1fr));
  gap: 10px;
}

.sn-norm-card {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
  min-height: 76px;
  height: auto;
  width: 100% !important;
  max-width: none !important;
  min-width: 0;
  margin: 0;
  padding: 12px 14px;
  border-radius: 12px;
  border: 1.5px solid #dee4f0;
  background: #fff;
  cursor: pointer;
  text-align: left;
  font-family: Lato, sans-serif;
  box-sizing: border-box;
  transition: border-color 0.14s, background 0.14s, box-shadow 0.14s,
    transform 0.14s;
}

.sn-norm-card:hover {
  border-color: #8b99b4;
  background: #fff;
  transform: translateY(-1px);
}

.sn-norm-card:focus-visible {
  outline: none;
  border-color: #0d9b87;
  box-shadow: 0 0 0 3px rgba(13, 155, 135, 0.28);
}

.sn-norm-card-top {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
}

.sn-norm-card.is-active {
  border-color: #0d9b87;
  background: #f2faf8;
  box-shadow: 0 0 0 3px rgba(13, 155, 135, 0.12);
}

.sn-norm-card-mark {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 1.5px solid #c5d0d4;
  display: grid;
  place-items: center;
  flex-shrink: 0;
}

.sn-norm-card.is-active .sn-norm-card-mark {
  border-color: #0d9b87;
  background: #0d9b87;
  color: #fff;
}

.sn-norm-card-mark svg {
  opacity: 0;
}

.sn-norm-card.is-active .sn-norm-card-mark svg {
  opacity: 1;
}

.sn-norm-card-label {
  font-size: 15px;
  font-weight: 800;
  color: #0b1e2d;
  line-height: 1.25;
  min-width: 0;
  overflow-wrap: anywhere;
}

.sn-norm-card-hint {
  font-size: 13.5px;
  font-weight: 600;
  color: #8b99b4;
  line-height: 1.35;
  width: 100%;
  overflow-wrap: anywhere;
}

.sn-tools {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  flex-wrap: wrap;
  margin-bottom: 12px;
}

.sn-tools-count {
  font-size: 13.5px;
  font-weight: 700;
  color: #076b5c;
  background: #e2f7f2;
  padding: 4px 10px;
  border-radius: 999px;
}

.sn-tools-actions {
  display: flex;
  gap: 6px;
}

.sn-tool-btn {
  width: auto !important;
  height: 32px;
  margin: 0;
  padding: 0 12px;
  border-radius: 8px;
  border: 1px solid #dee4f0;
  background: #fff;
  color: #00146d;
  font-family: Lato, sans-serif;
  font-size: 13.5px;
  font-weight: 700;
  cursor: pointer;
  transition: border-color 0.14s, background 0.14s;
}

.sn-tool-btn:hover:not(:disabled) {
  border-color: #00146d;
}

.sn-tool-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.sn-preview {
  margin-top: 14px;
  border: 1px solid #eaeff7;
  border-radius: 12px;
  background: #fff;
  overflow: hidden;
}

.sn-preview-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 12px 14px;
  border-bottom: 1px solid #eaeff7;
}

.sn-preview-head h4 {
  margin: 0;
  font-size: 14.5px;
  font-weight: 700;
  color: #0b1e2d;
}

.sn-preview-count {
  font-size: 11.5px;
  font-weight: 700;
  color: #076b5c;
  background: #e2f7f2;
  padding: 3px 8px;
  border-radius: 999px;
}

.sn-preview-list {
  max-height: 180px;
  overflow-y: auto;
  margin: 0;
  padding: 8px;
  list-style: none;
}

.sn-preview-item {
  padding: 10px 12px;
  border-radius: 8px;
  font-size: 14.5px;
  font-weight: 600;
  color: #0b1e2d;
  background: #fff;
  border: 1px solid #eaeff7;
}

.sn-preview-item + .sn-preview-item {
  margin-top: 6px;
}

.sn-preview-empty,
.sn-preview-loading {
  padding: 22px 16px;
  text-align: center;
  font-size: 14.5px;
  font-weight: 600;
  color: #8b99b4;
  line-height: 1.45;
}

.sn-aside-note {
  margin-top: 14px;
  display: flex;
  gap: 10px;
  padding: 12px 14px;
  border-radius: 10px;
  background: #e6eff8;
  border-left: 3px solid #22548a;
  font-size: 13px;
  color: #22548a;
  line-height: 1.45;
}

.sn-aside-note svg {
  flex-shrink: 0;
  margin-top: 1px;
}

.sn-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 12px;
}

.sn-chip {
  display: inline-flex;
  align-items: center;
  height: 24px;
  padding: 0 10px;
  border-radius: 999px;
  background: #e1f4f0;
  color: #076b5c;
  font-size: 11.5px;
  font-weight: 700;
}

@media (max-width: 900px) {
  .sn-layout {
    grid-template-columns: 1fr;
  }

  .sn-head-aside {
    width: 100%;
    align-items: stretch;
  }

  .sn-save {
    width: 100% !important;
  }

  .sn-title {
    font-size: 26px;
    max-width: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/SelectNorm/selectNorm.css"],"names":[],"mappings":"AAAA,2CAA2C;;AAE3C;EACE,iBAAiB;EACjB,cAAc;EACd,uBAAuB;EACvB,8BAA8B;EAC9B,sBAAsB;EACtB,6BAA6B;EAC7B,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,0EAA0E;EAC1E,6BAA6B;EAC7B,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,oDAAoD;AACtD;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,4CAA4C;EAC5C,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,oDAAoD;EACpD,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,uBAAuB;EACvB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA,qEAAqE;AACrE;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;EACtB,0BAA0B;EAC1B,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,sBAAsB;EACtB;mBACiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,gDAAgD;AAClD;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,WAAW;IACX,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;AACF","sourcesContent":["/* Select-norm — first-run setup (INCYIA) */\n\n.sn-page {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 12px 20px 56px;\n  min-height: calc(100vh - 72px);\n  box-sizing: border-box;\n  font-family: Lato, sans-serif;\n  color: #0b1e2d;\n  background: #fff;\n}\n\n.sn-head {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 20px;\n  flex-wrap: wrap;\n  margin-bottom: 22px;\n}\n\n.sn-eyebrow {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  margin: 0 0 10px;\n  padding: 5px 11px 5px 5px;\n  border-radius: 999px;\n  background: #e2f7f2;\n  border: 1px solid #c8ebe4;\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: #076b5c;\n}\n\n.sn-eyebrow-dot {\n  width: 22px;\n  height: 22px;\n  border-radius: 50%;\n  display: grid;\n  place-items: center;\n  background: #0d9b87;\n  color: #fff;\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0;\n}\n\n.sn-title {\n  margin: 0;\n  font-size: 30px;\n  font-weight: 800;\n  letter-spacing: -0.03em;\n  line-height: 1.12;\n  background: linear-gradient(115deg, #00146d 0%, #00146d 45%, #0d9b87 100%);\n  -webkit-background-clip: text;\n  background-clip: text;\n  color: transparent;\n  max-width: 18ch;\n}\n\n.sn-title-bar {\n  width: 44px;\n  height: 4px;\n  border-radius: 99px;\n  margin-top: 12px;\n  background: linear-gradient(90deg, #0d9b87, #4fe0c2);\n}\n\n.sn-sub {\n  margin: 12px 0 0;\n  font-size: 16px;\n  font-weight: 600;\n  color: #5b6b87;\n  line-height: 1.55;\n  max-width: 48ch;\n}\n\n.sn-head-aside {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 12px;\n  flex-shrink: 0;\n}\n\n.sn-progress {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.sn-progress-seg {\n  width: 36px;\n  height: 6px;\n  border-radius: 99px;\n  background: #dee4f0;\n  transition: background 0.2s;\n}\n\n.sn-progress-seg.is-on {\n  background: #0d9b87;\n}\n\n.sn-progress-label {\n  font-size: 13px;\n  font-weight: 700;\n  color: #8b99b4;\n  margin-left: 2px;\n}\n\n.sn-save {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  height: 46px;\n  padding: 0 22px;\n  border: none;\n  border-radius: 10px;\n  background: #00146d;\n  color: #fff;\n  font-family: Lato, sans-serif;\n  font-size: 14.5px;\n  font-weight: 700;\n  cursor: pointer;\n  width: auto !important;\n  box-shadow: 0 1px 2px rgba(0, 20, 109, 0.35);\n  transition: background 0.14s, opacity 0.14s;\n}\n\n.sn-save:hover:not(:disabled) {\n  background: #1b2f8f;\n}\n\n.sn-save:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n  box-shadow: none;\n}\n\n.sn-layout {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 20px;\n  align-items: start;\n}\n\n.sn-col {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  min-width: 0;\n}\n\n.sn-card {\n  background: #fff;\n  border: 1px solid #dee4f0;\n  border-radius: 16px;\n  box-shadow: 0 12px 36px -28px rgba(0, 20, 109, 0.35);\n  overflow: hidden;\n}\n\n.sn-card-head {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  padding: 18px 20px 14px;\n  border-bottom: 1px solid #eaeff7;\n  background: #fff;\n}\n\n.sn-card-n {\n  width: 28px;\n  height: 28px;\n  border-radius: 8px;\n  display: grid;\n  place-items: center;\n  font-size: 12.5px;\n  font-weight: 800;\n  background: #eaeff7;\n  color: #5b6b87;\n  flex-shrink: 0;\n}\n\n.sn-card-n.is-done {\n  background: #0d9b87;\n  color: #fff;\n}\n\n.sn-card-copy h3 {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 800;\n  color: #0b1e2d;\n  letter-spacing: -0.01em;\n}\n\n.sn-card-copy p {\n  margin: 3px 0 0;\n  font-size: 14.5px;\n  font-weight: 600;\n  color: #8b99b4;\n  line-height: 1.4;\n}\n\n.sn-card-body {\n  padding: 16px 20px 20px;\n}\n\n/* Equal norm tiles — override global button { width: fit-content } */\n.sn-norm-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(165px, 1fr));\n  gap: 10px;\n}\n\n.sn-norm-card {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 6px;\n  min-height: 76px;\n  height: auto;\n  width: 100% !important;\n  max-width: none !important;\n  min-width: 0;\n  margin: 0;\n  padding: 12px 14px;\n  border-radius: 12px;\n  border: 1.5px solid #dee4f0;\n  background: #fff;\n  cursor: pointer;\n  text-align: left;\n  font-family: Lato, sans-serif;\n  box-sizing: border-box;\n  transition: border-color 0.14s, background 0.14s, box-shadow 0.14s,\n    transform 0.14s;\n}\n\n.sn-norm-card:hover {\n  border-color: #8b99b4;\n  background: #fff;\n  transform: translateY(-1px);\n}\n\n.sn-norm-card:focus-visible {\n  outline: none;\n  border-color: #0d9b87;\n  box-shadow: 0 0 0 3px rgba(13, 155, 135, 0.28);\n}\n\n.sn-norm-card-top {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  width: 100%;\n}\n\n.sn-norm-card.is-active {\n  border-color: #0d9b87;\n  background: #f2faf8;\n  box-shadow: 0 0 0 3px rgba(13, 155, 135, 0.12);\n}\n\n.sn-norm-card-mark {\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  border: 1.5px solid #c5d0d4;\n  display: grid;\n  place-items: center;\n  flex-shrink: 0;\n}\n\n.sn-norm-card.is-active .sn-norm-card-mark {\n  border-color: #0d9b87;\n  background: #0d9b87;\n  color: #fff;\n}\n\n.sn-norm-card-mark svg {\n  opacity: 0;\n}\n\n.sn-norm-card.is-active .sn-norm-card-mark svg {\n  opacity: 1;\n}\n\n.sn-norm-card-label {\n  font-size: 15px;\n  font-weight: 800;\n  color: #0b1e2d;\n  line-height: 1.25;\n  min-width: 0;\n  overflow-wrap: anywhere;\n}\n\n.sn-norm-card-hint {\n  font-size: 13.5px;\n  font-weight: 600;\n  color: #8b99b4;\n  line-height: 1.35;\n  width: 100%;\n  overflow-wrap: anywhere;\n}\n\n.sn-tools {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  flex-wrap: wrap;\n  margin-bottom: 12px;\n}\n\n.sn-tools-count {\n  font-size: 13.5px;\n  font-weight: 700;\n  color: #076b5c;\n  background: #e2f7f2;\n  padding: 4px 10px;\n  border-radius: 999px;\n}\n\n.sn-tools-actions {\n  display: flex;\n  gap: 6px;\n}\n\n.sn-tool-btn {\n  width: auto !important;\n  height: 32px;\n  margin: 0;\n  padding: 0 12px;\n  border-radius: 8px;\n  border: 1px solid #dee4f0;\n  background: #fff;\n  color: #00146d;\n  font-family: Lato, sans-serif;\n  font-size: 13.5px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: border-color 0.14s, background 0.14s;\n}\n\n.sn-tool-btn:hover:not(:disabled) {\n  border-color: #00146d;\n}\n\n.sn-tool-btn:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.sn-preview {\n  margin-top: 14px;\n  border: 1px solid #eaeff7;\n  border-radius: 12px;\n  background: #fff;\n  overflow: hidden;\n}\n\n.sn-preview-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  padding: 12px 14px;\n  border-bottom: 1px solid #eaeff7;\n}\n\n.sn-preview-head h4 {\n  margin: 0;\n  font-size: 14.5px;\n  font-weight: 700;\n  color: #0b1e2d;\n}\n\n.sn-preview-count {\n  font-size: 11.5px;\n  font-weight: 700;\n  color: #076b5c;\n  background: #e2f7f2;\n  padding: 3px 8px;\n  border-radius: 999px;\n}\n\n.sn-preview-list {\n  max-height: 180px;\n  overflow-y: auto;\n  margin: 0;\n  padding: 8px;\n  list-style: none;\n}\n\n.sn-preview-item {\n  padding: 10px 12px;\n  border-radius: 8px;\n  font-size: 14.5px;\n  font-weight: 600;\n  color: #0b1e2d;\n  background: #fff;\n  border: 1px solid #eaeff7;\n}\n\n.sn-preview-item + .sn-preview-item {\n  margin-top: 6px;\n}\n\n.sn-preview-empty,\n.sn-preview-loading {\n  padding: 22px 16px;\n  text-align: center;\n  font-size: 14.5px;\n  font-weight: 600;\n  color: #8b99b4;\n  line-height: 1.45;\n}\n\n.sn-aside-note {\n  margin-top: 14px;\n  display: flex;\n  gap: 10px;\n  padding: 12px 14px;\n  border-radius: 10px;\n  background: #e6eff8;\n  border-left: 3px solid #22548a;\n  font-size: 13px;\n  color: #22548a;\n  line-height: 1.45;\n}\n\n.sn-aside-note svg {\n  flex-shrink: 0;\n  margin-top: 1px;\n}\n\n.sn-chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin-top: 12px;\n}\n\n.sn-chip {\n  display: inline-flex;\n  align-items: center;\n  height: 24px;\n  padding: 0 10px;\n  border-radius: 999px;\n  background: #e1f4f0;\n  color: #076b5c;\n  font-size: 11.5px;\n  font-weight: 700;\n}\n\n@media (max-width: 900px) {\n  .sn-layout {\n    grid-template-columns: 1fr;\n  }\n\n  .sn-head-aside {\n    width: 100%;\n    align-items: stretch;\n  }\n\n  .sn-save {\n    width: 100% !important;\n  }\n\n  .sn-title {\n    font-size: 26px;\n    max-width: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
